module.exports = __webpack_public_path__ + "static/media/dheta-2.863c3534.jpg";